import { useContext, useEffect, useState } from "react";
import WebplaceContext from "../../store/webplace-context";

import HeroImg from "../../assets/mainItems/heroImg.png";
import "./RoomNumber.css";
import ButtonFormat from "../../components/shared/ButtonFormat/ButtonFormat";
import Navbar from "../../components/ui/navbar/Navbar";


import HotelRooms from "../../data/hotelRooms.json"

const RoomNumber = () => {
  const stylesCtx = useContext(WebplaceContext).brandsInformation.brands_styles;
  const [valueRoom, setValueRoom] = useState("")
  const [infoRoom, setInfoRoom] = useState({ value: 0 })
  const [paramsString, setParamsString] = useState("")
  const [showErrorMsg, setShowErrorMsg] = useState(false)

  useEffect(() => {
    const fullUrl = window.location.href

    const paramIndex = fullUrl.indexOf("/restaurants")

    setParamsString(fullUrl.substring(paramIndex + "/restaurants".length))
  }, [])

  const inputNumberChange = (e) => {
    const result = e.target.value.replace(/\D/g, '');
    if (showErrorMsg) {
      setShowErrorMsg(false)
    }
    setValueRoom(result)

    // Check if input has 4 characters for duplicates
    if (e.target.value.length === 4) {
      const occurrences = {};

      // Iterate through the array
      HotelRooms.forEach(obj => {
        const { value, type } = obj;

        // DONT TOUCH THIS CODE IDK WHY EVERYTHIGN EXPLOTES IF YOU MOVE ANYTHING!
        // Check if the value (converted to string) matches the chosenValue
        if (String(value) === e.target.value) {
          // Check if the type has occurred before
          if (!occurrences[type]) {
            occurrences[type] = 1;
          }
        }
      });
    }

  }

  const handleRoomSearch = (e) => {
    e.preventDefault()
    setShowErrorMsg(false)


    // Find the object with the room and type
    // eslint-disable-next-line

    // In case we need to add values
    // const roomInfo = HotelRooms.find(obj => obj.value == valueRoom)
    // eslint-disable-next-line
    const roomInfo = HotelRooms.find(obj => obj == valueRoom)

    // Check if room exists
    // Room with length 4
    if (roomInfo !== undefined && valueRoom.length === 4) {
      setInfoRoom({ value: valueRoom })
    } else {
      setShowErrorMsg(true)
      return null
    }
  }

  useEffect(() => {
    // Check if both value and type are truthy before redirecting
    if (infoRoom.value) {
      if (paramsString === "/the-wharf-at-sunset-walk") {
        window.location.href = `https://order.tryotter.com/s${paramsString}/3274-margaritaville-boulevard-kissimmee/67061ac0-6eb9-4bd0-a706-f566db9c1d43?table_number=${infoRoom.value}`
      } else if (paramsString === "/lizzie's-memphis-style-bbq-room-service") {
        window.location.href = `https://order.tryotter.com/s${paramsString}/3720-margaritaville-blvd-kissimmee/44fbbf3e-8961-4442-962c-0358f040822a?table_number=${infoRoom.value}`
      } else {
        window.location.href = `/`
      }
    }
  }, [infoRoom, paramsString]);

  return (
    <div>
      <a href="#main" className="skip-to-main">Skip to main content</a>
      <Navbar />
      <div className="spacer"></div>
      <div className="room-number-main-info-wrapper" id="main">
        <img
          src={HeroImg}
          alt="main show food"
          className="room-number-hero-image-style"
        />
        <div
          className="room-number-title"
          style={{
            color: stylesCtx.title_text_color,
            borderBottom: `2px solid ${stylesCtx.title_border_color}`,
          }}
          role="heading" aria-level="1"
        >
          Room number
        </div>

        <div className="room-number-container-wrapper">
          <div className="room-number-subtitle">
            Please enter your room number so your order may be registered correctly.
          </div>
          <form className="input-wrapper" onSubmit={handleRoomSearch}>

            <div style={{ marginBottom: `${!showErrorMsg ? "30px" : ""}` }} className="input-inner-wrapper">
              <input placeholder="Room Number" maxLength={4} value={valueRoom} onChange={inputNumberChange} className="input-number-style" inputMode="numeric" aria-label={`Room number select`} />
              {showErrorMsg && <div className="input-error-msg">Room not found. Please check if there are any errors.</div>}

            </div>
            <div id="button-format">
              <ButtonFormat
                btnSize="1.5"
                showArrow={true}
                arrowAtStart={true}
                arrowColor="#0fa991"
                showBorder={true}
                borderColor="#0fa991"
                backgroundColor="white"
                fontColor="black"
                capitalizeText={false}
                btnText="Enter"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RoomNumber;
